import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CropperPosition, Dimensions, ImageCroppedEvent, base64ToFile } from 'ngx-image-cropper';

@Component({
  selector: 'app-image-crop-dialog',
  templateUrl: './image-crop-dialog.component.html',
  styleUrls: ['./image-crop-dialog.component.scss'],
})
export class ImageCropDialogComponent implements OnChanges {
  @Input() visible = false;
  @Input() imageFile?: File;
  @Input() aspectRatio?: number;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() croppedFile = new EventEmitter<File>();

  imageBase64?: string;
  cropperPosition: CropperPosition = { x1: 0, y1: 0, x2: 0, y2: 0 };
  private cropEvent?: ImageCroppedEvent;
  private originalName = 'cropped.jpg';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imageFile'] && this.imageFile) {
      this.originalName = this.imageFile.name;
      this.cropEvent = undefined;
      const reader = new FileReader();
      reader.onload = (e) => { this.imageBase64 = e.target?.result as string; };
      reader.readAsDataURL(this.imageFile);
    }
  }

  onImageCropped(event: ImageCroppedEvent): void {
    this.cropEvent = event;
  }

  // 保險起見，強制把初始裁切框設成滿版整張圖——不要完全依賴 ngx-image-cropper
  // 自己的預設尺寸計算，圖片太高的話有可能算出來的框沒有蓋滿整張，下半部會看不到。
  onCropperReady(dimensions: Dimensions): void {
    this.cropperPosition = { x1: 0, y1: 0, x2: dimensions.width, y2: dimensions.height };
  }

  confirm(): void {
    if (this.cropEvent?.base64) {
      // ngx-image-cropper 的 <image-cropper format="jpeg"> 一律把裁切結果編碼成 JPEG，
      // 跟原始檔案的格式無關。base64ToFile() 會正確地從這個 data URL 產生 JPEG 的
      // Blob——不要再把它的 type 改回原始檔案的 mime（例如 image/png）：標示的
      // type 一定要跟實際的位元組內容一致，否則瀏覽器用 <img> 解析這個 blob: URL
      // 時會失敗，畫面上就會顯示成損毀的圖片。
      const blob = base64ToFile(this.cropEvent.base64);
      const file = new File([blob], this.withJpgExtension(this.originalName), { type: blob.type });
      this.croppedFile.emit(file);
    }
    this.close();
  }

  private withJpgExtension(fileName: string): string {
    return fileName.replace(/\.[^./\\]+$/, '') + '.jpg';
  }

  close(): void {
    this.imageBase64 = undefined;
    this.cropEvent = undefined;
    this.visibleChange.emit(false);
  }
}
